/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetPhoneResponseAllOf } from './GetPhoneResponseAllOf';
import {
    GetPhoneResponseAllOfFromJSON,
    GetPhoneResponseAllOfFromJSONTyped,
    GetPhoneResponseAllOfToJSON,
} from './GetPhoneResponseAllOf';

/**
 * 
 * @export
 * @interface GetPhoneResponse
 */
export interface GetPhoneResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPhoneResponse
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the GetPhoneResponse interface.
 */
export function instanceOfGetPhoneResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPhoneResponseFromJSON(json: any): GetPhoneResponse {
    return GetPhoneResponseFromJSONTyped(json, false);
}

export function GetPhoneResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPhoneResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
    };
}

export function GetPhoneResponseToJSON(value?: GetPhoneResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phoneNumber': value.phoneNumber,
    };
}

